import ArrowBack from "@mui/icons-material/ArrowBack";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import EditOutlined from "@mui/icons-material/EditOutlined";
import AssignmentOutlined from "@mui/icons-material/AssignmentOutlined";
import Description from "@mui/icons-material/Description";
import Email from "@mui/icons-material/Email";
import Explore from "@mui/icons-material/Explore";
import LinkedIn from "@mui/icons-material/LinkedIn";
import LocationOn from "@mui/icons-material/LocationOn";
import NotesOutlined from "@mui/icons-material/NotesOutlined";
import Person from "@mui/icons-material/Person";
import Phone from "@mui/icons-material/Phone";
import Work from "@mui/icons-material/Work";
import { Avatar, Box, Button, Chip, IconButton, Tab, Tabs, Typography, useMediaQuery } from "@mui/material";
import moment from "moment";
import "moment/locale/fr";
import React, { useEffect, useState } from "react";
import { GiOnTarget } from "react-icons/gi";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { ContactButtonAndEditButton } from "../../../components/ContactButtonAndEditButton/ContactButtonAndEditButton";
import LabelHtmlToTextCustom from "../../../components/LabelHtmlToTextCustom/LabelHtmlToTextCustom";
import Loader from "../../../components/Loader/Loader";
import TabPanelTaches from "../../../components/TabPanelTaches/TabPanelTaches";
import { TABLE } from "../../../enums/tablesEnum";
import { getDetails } from "../../../services/ContactService";
import { deleteTacheContact, getAll, getAllTachesFaites } from "../../../services/TacheContactService";
import { getUserData } from "../../../utils/FunctionHelpers";
import { theme } from "../../../utils/Theme";
import CandidatsAssocie from "./Tabs/CandidatsAssocie";
import MissionEnCours from "./Tabs/MissionEnCours";
import NotesContact from "./Tabs/NotesContact";
import PresentationSociete from "./Tabs/PresentationSociete";
import Prospection from "./Tabs/Prospection";
import "./VisualiserContact.css";
import "../../../styles/heroToolbar.css";
import VisualiserDate from "./VisualiserDate";
import { withSnackbar } from "../../../utils/SnackbarHOC";
import { AppButton } from "../../../components/UI";

function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box p={1}>{children}</Box>}
    </div>
  );
}

const formatValue = (value) => ([null, "", "null", undefined].includes(value) ? "-" : value);
const formatPhone = (value) => value ? value.replace(/(\d{2})\D?(\d{1})\D?(\d{2})\D?(\d{2})\D?(\d{2})\D?(\d{2})/, "$1 $2 $3 $4 $5 $6") : "-";
const cleanUrl = (value) => {
  if (!value || value === "-") return "";
  return String(value).startsWith("http") ? value : `https://${value}`;
};

const InfoCard = ({ title, rows }) => (
  <section className="contact-view-infoCard">
    <div className="contact-view-infoTitle">
      <span />
      {title}
    </div>
    <div className="contact-view-infoRows">
      {rows.map((row) => (
        <div className="contact-view-infoRow" key={row.label}>
          <span className="contact-view-infoLabel">{row.icon}{row.label}</span>
          <span className="contact-view-infoValue">
            {row.href ? (
              <a href={row.href} target="_blank" rel="noreferrer">{row.value}</a>
            ) : row.rich ? (
              <LabelHtmlToTextCustom data={row.value} />
            ) : (
              row.value
            )}
          </span>
        </div>
      ))}
    </div>
  </section>
);

const VisualiserContact = ({ snackbarShowMessage }) => {
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = useState(history.location.state?.tabIndex || 0);
  const [contact, setContact] = useState({});
  const [loading, setLoading] = useState(true);
  const [noteAdded, setNoteAdded] = useState(0);
  const { idContact, id } = useParams();
  const idCurrentUser = getUserData().uuid;
  const isSmMode = useMediaQuery(theme.breakpoints.between(0, 480));
  const isMdMode = useMediaQuery(theme.breakpoints.between(481, 992));

  const props = {
    nomSociete: contact.nom_societ,
    deleteTache: deleteTacheContact,
    getAll,
    getAllTachesFaites,
    tacheFrom: TABLE.CONTACT,
    ...contact,
    id,
    onNoteAdded: () => setNoteAdded((prev) => prev + 1),
  };

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        const { data } = await getDetails(idContact);
        if (isMounted) {
          setContact(data);
          setLoading(false);
        }
      } catch (error) {
        if (isMounted) setLoading(false);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [idContact]);

  useEffect(() => {
    const etat = new URLSearchParams(location.search).get("etat");
    if (etat === "updated") snackbarShowMessage("Contact mis à jour via l'extension", "warning", 4000);
    else if (etat === "created") snackbarShowMessage("Contact ajouté via l'extension", "success", 4000);
  }, [location.search, snackbarShowMessage]);

  const handleTabs = (_event, newValue) => setValue(newValue);

  const editContact = () => {
    history.push({
      pathname: `/societe/${id}/contacts/${idContact}/edit`,
      state: { nomSociete: contact.nom_societe },
    });
  };

  const contactButtonAndEditButtonProps = {
    id: idContact,
    prenom: contact.prenom,
    nom: contact.nom,
    modalOpenSms: false,
    setModalOpenSms: () => {},
    uuid: contact.uuid,
    loadData: null,
    history,
    email: contact.email,
    setLoadData: () => {},
    edit: editContact,
    telephone: contact.telFix,
    props: { ...contact },
  };

  const fullName = `${formatValue(contact.titre) !== "-" ? `${contact.titre} ` : ""}${formatValue(contact.prenom)} ${formatValue(contact.nom)}`.trim();
  const initials = `${contact.prenom?.[0] || ""}${contact.nom?.[0] || ""}`.toUpperCase() || "CT";
  const updatedAt = contact.updatedAt?.date || contact.updatedAt;

  const infoSections = [
    {
      title: "Contact",
      rows: [
        { label: "Mobile", value: formatPhone(contact.mobile), icon: <Phone fontSize="small" /> },
        { label: "Tel. fixe direct", value: formatPhone(contact.telFix), icon: <Phone fontSize="small" /> },
        { label: "Email pro", value: formatValue(contact.email), href: contact.email ? `mailto:${contact.email}` : "", icon: <Email fontSize="small" /> },
        { label: "LinkedIn", value: formatValue(contact.linkedIn), href: cleanUrl(contact.linkedIn), icon: <LinkedIn fontSize="small" /> },
        { label: "Direction", value: formatValue(contact.directionName) },
        { label: "Localisation", value: formatValue(contact.localisation), icon: <LocationOn fontSize="small" /> },
      ],
    },
    {
      title: "Emploi",
      rows: [
        { label: "Societe", value: formatValue(contact.nom_societe), icon: <Work fontSize="small" /> },
        { label: "Fonction", value: formatValue(contact.fonction) },
        { label: "Statut", value: formatValue(contact.statut) },
        { label: "Delivery Manager", value: formatValue(contact.Manager) },
        { label: "Sachez que", value: formatValue(contact.sachezQue), rich: true },
      ],
    },
  ];

  const tabs = [
    { name: "NOTES", icon: <NotesOutlined />, component: <NotesContact {...props} /> },
    { name: "TÂCHES", icon: <AssignmentOutlined />, component: <TabPanelTaches {...props} /> },
    { name: "DESCRIPTION", icon: <Description />, component: <PresentationSociete {...props} /> },
    { name: "MISSIONS", icon: <GiOnTarget />, component: <MissionEnCours {...props} /> },
    { name: "CANDIDATS", icon: <Person />, component: <CandidatsAssocie {...props} /> },
    { name: "PROSPECTION", icon: <Explore />, component: <Prospection idCurrentUser={idCurrentUser} /> },
  ];

  return (
    <Box className="contact-view-page">
      {loading ? (
        <Loader />
      ) : (
        <>
          <div className="contact-view-actions">
            <div className="contact-view-actionsLeft">
              <IconButton className="contact-view-back" onClick={() => history.goBack()} title="Retour">
                <ArrowBack />
              </IconButton>
              <AppButton variant="secondary" size="small" disabled startIcon={<ChevronLeft fontSize="small" />}>Précédent</AppButton>
              <AppButton variant="secondary" size="small" endIcon={<ChevronRight fontSize="small" />}>Suivant</AppButton>
            </div>
            <AppButton className="contact-view-edit" variant="primary" size="small" onClick={editContact} startIcon={<EditOutlined fontSize="small" />}>
              Modifier le contact
            </AppButton>
          </div>

          <header className="contact-view-hero">
            <div className="contact-view-identity">
              <Avatar className="contact-view-avatar">{initials}</Avatar>
              <div className="contact-view-titleWrap">
                <div className="contact-view-titleLine">
                  <Typography className="contact-view-title">{fullName}</Typography>
                  {contact.statut && <Chip className="contact-view-chip" label={contact.statut} />}
                </div>
                <Typography className="contact-view-subtitle">
                  {formatValue(contact.nom_societe)}
                  {contact.fonction ? ` - ${contact.fonction}` : ""}
                  {updatedAt ? ` - mise à jour : ${moment(updatedAt).locale("fr").format("DD MMMM YYYY - HH:mm")}` : ""}
                </Typography>
              </div>
            </div>
            <div className="contact-view-heroActions hero-toolbar">
              <ContactButtonAndEditButton {...contactButtonAndEditButtonProps} />
            </div>
          </header>

          <section className="contact-view-dateCard">
            <VisualiserDate onNoteAdded={noteAdded} />
          </section>

          <main className="contact-view-layout">
            <aside className="contact-view-sidebar">
              {infoSections.map((section) => <InfoCard key={section.title} {...section} />)}
            </aside>

            <section className="contact-view-workspace">
              <Box className="contact-view-tabsBar">
                <Tabs
                  value={value}
                  onChange={handleTabs}
                  orientation="horizontal"
                  variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
                  sx={{
                    '& .MuiTabs-indicator': { backgroundColor: '#fff', height: 3, borderRadius: '3px 3px 0 0' },
                    '& .MuiTabs-scrollButtons': { color: '#fff', width: 32, '&.Mui-disabled': { opacity: 0.3 } },
                  }}
                >
                  {tabs.map((tab) => (
                    <Tab
                      key={tab.name}
                      label={(
                        <Box sx={{ display: "flex", gap: "8px", alignItems: "center", color: "inherit" }}>
                          {tab.icon}
                          {!(isSmMode || isMdMode) && <span>{tab.name}</span>}
                        </Box>
                      )}
                    />
                  ))}
                </Tabs>
              </Box>
              <div className="contact-view-tabPanel">
                {tabs.map((tab, index) => (
                  <TabPanel key={tab.name} value={value} index={index}>
                    {tab.component}
                  </TabPanel>
                ))}
              </div>
            </section>
          </main>
        </>
      )}
    </Box>
  );
};

export default withSnackbar(VisualiserContact);
